const KEY = 'USER';

export { KEY };
